export enum EServerError {
  CONFLICT = 'conflict',
  INVALID_CREDENTIALS = 'invalid_credentials',
  TFA_REQUIRED = '2fa_required',
  TFA_UNCONFIGURED = '2fa_unconfigured',
  OTP_COOLDOWN = 'otp_cooldown',
  OTP_INVALID = 'otp_invalid',
  OTP_EXPIRED = 'otp_expired',
  OTP_MAX_ATTEMPTS = 'otp_max_attempts',
  WRONG_MIMETYPE = 'file_wrong_mimetype',
  DEVICE_ID_ALREADY_REGISTERED = 'device_id_already_registered',
  PHONE_ALREADY_REGISTERED = 'phone_already_registered',
  USER_ALREADY_REGISTERED = 'user_already_registered',
  USER_ALREADY_EXISTS = 'user_already_exists',
  USER_HAS_ROLES_IN_OTHER_INSTITUTIONS = 'user_has_roles_in_other_institutions',
  DUPLICATE_NPI = 'duplicate_npi',
  UNKNOWN_ERROR = 'unknown_error',
  BAD_PARAMS = 'bad_params',
}

// Error codes returned via /login?error=<code> after an SSO (Google/Microsoft) callback.
export enum ESsoLoginError {
  // No account matches the provider identity or its email.
  USER_NOT_FOUND = 'user_not_found',
  // Account exists but is deactivated.
  USER_INACTIVE = 'user_inactive',
  // Account exists but is not a patient (SSO login is patient-only).
  NOT_PERMITTED = 'not_permitted',
  // The IdP did not assert a verified email.
  EMAIL_NOT_VERIFIED = 'email_not_verified',
  // Generic fallback for anything else.
  CALLBACK_ERROR = 'callback_error',
}
